import './App.css';
import { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes } from 'react-router-dom';
import AxiosInterceptorSetup from './shared/services/AxiosInterceptorSetup';
import SessionBootstrap from './shared/SessionBootstrap/SessionBootstrap';
import IdleSessionWarning from './shared/SessionBootstrap/IdleSessionWarning';
import { bindSidebarResize, initSidebarState } from './shared/utils/sidebarMobile';
import {
  publicRoutes,
  coreRoutes,
  superAdminRoutes,
  crmRoutes,
  realestateRoutes,
  immigrationRoutes,
  educationRoutes,
  hrRoutes,
  financeRoutes,
  socialRoutes,
} from './routes';
import AnalyticsRouteTracker from './shared/analytics/AnalyticsRouteTracker';

function App() {
  const isMetaOAuthCallback =
    typeof window !== 'undefined'
    && window.location.pathname.toLowerCase().startsWith('/meta-oauth-callback');

  useEffect(() => {
    initSidebarState();
    return bindSidebarResize();
  }, []);

  if (isMetaOAuthCallback) {
    return (
      <div>
        <Router>
          <AnalyticsRouteTracker />
          <Suspense fallback={<div className="p-4">Loading…</div>}>
            <Routes>
              {publicRoutes}
            </Routes>
          </Suspense>
        </Router>
      </div>
    );
  }

  return (
    <SessionBootstrap>
      <AxiosInterceptorSetup>
        <div>
          <Router>
            <AnalyticsRouteTracker />
            <IdleSessionWarning />
            <Suspense fallback={<div className="p-4">Loading…</div>}>
              <Routes>
                {publicRoutes}
                {coreRoutes}
                {superAdminRoutes}
                {crmRoutes}
                {realestateRoutes}
                {immigrationRoutes}
                {educationRoutes}
                {hrRoutes}
                {financeRoutes}
                {socialRoutes}
              </Routes>
            </Suspense>
          </Router>
        </div>
      </AxiosInterceptorSetup>
    </SessionBootstrap>
  );
}

export default App;
